<template>
    <div class="lead-generation-container">
        <div class="quote-content">
            <div class="quote-address-section" v-show="activeSection == 'locations'">

                <h2>Locations</h2>
                <p>Select the locations you want to include on the quote</p>

                <div class="location-container">
                    <div class="location" :class="{active: isSelectedLocation(location) }" v-for="location in leadLocations" @click="toggleLocation(location)">
                        {{location.location.formatted_address}}
                    </div>
                </div>
                <button @click="configureProducts" class="btn btn-primary">NEXT: Choose Products <i class="fa fa-chevron-right"></i> </button>

            </div>

            <div class="quote-product-section" v-if="quote.locations.length" v-show="activeSection == 'products'">

                <p>Configure Products for:</p>
                <h2>{{ quote.locations[locationIndex].location.formatted_address }}</h2>


                <br />
                <br />
                <div class="product-container">
                        <div class="product-section access-container">

                            <div class="product-choice-header" >
                                Access
                            </div>
                            <div v-for="access, accessIndex in attributeTree.access"
                                class="product-choice"
                                :class="{ active: activeProduct.access == access.name, 'disabled': typeof activeProduct.access != 'undefined' && activeProduct.access != access.name  }"
                                @click="setProductChoice('access', accessIndex, access.name)"
                            >
                                {{access.name || '-'}}
                            </div>
                            <br />

                            <dropdown-confirmation
                                    direction="left"
                                    triggerBtnClass="btn-light"
                                    triggerBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Access'
                                    confirmBtnClass="btn-primary"
                                    confirmBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Item'
                                    @confirm="addItem('access')"
                                    @close="clearNewItem"
                                    keepalive
                            >
                                <slot>
                                   <label>Name</label>
                                    <input type="text" v-model="newItem" class="form-control" />
                                </slot>
                            </dropdown-confirmation>
                        </div>

                    <transition name="slide" mode="out-in">

                        <div class="product-section criteria-container" v-if="activeProduct.accessIndex > -1 && attributeTree.access[activeProduct.accessIndex]">

                            <div class="product-choice-header" >
                                Criteria

                            </div>

                            <div v-for="criteria, criteriaIndex in attributeTree.access[activeProduct.accessIndex].criteria"
                                 class="product-choice"
                                 :class="{ active: activeProduct.criteria == criteria.name, 'disabled': activeProduct.criteria && activeProduct.criteria != criteria.name  }"
                                 @click="setProductChoice('criteria',criteriaIndex, criteria.name)"
                            >
                                {{criteria.name || '-'}}
                            </div>
                            <br />
                            <dropdown-confirmation
                                    direction="left"
                                    triggerBtnClass="btn-light"
                                    triggerBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Criteria'
                                    confirmBtnClass="btn-primary"
                                    confirmBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Criteria'
                                    @confirm="addItem('criteria')"
                                    @close="clearNewItem"
                                    keepalive
                            >
                                <slot>
                                    <label>Name</label>
                                    <input type="text" v-model="newItem" class="form-control" />
                                </slot>
                            </dropdown-confirmation>

                        </div>
                    </transition>
                    <transition name="slide" mode="out-in">
                        <div class="product-section product-list-container" v-if="activeProduct.criteriaIndex > -1 && attributeTree.access[activeProduct.accessIndex] && attributeTree.access[activeProduct.accessIndex].criteria[activeProduct.criteriaIndex]">

                            <div class="product-choice-header" >
                                Product
                            </div>

                            <div v-for="product, productIndex in attributeTree.access[activeProduct.accessIndex].criteria[activeProduct.criteriaIndex].products"
                                 class="product-choice"
                                 :class="{ active: activeProduct.product == product.name, 'disabled': activeProduct.product && activeProduct.product != product.name  }"
                                 @click="setProductChoice('product',productIndex, product)"
                            >
                                {{product.name}}
                            </div>
                            <br />
                            <dropdown-confirmation
                                    direction="left"
                                    triggerBtnClass="btn-light"
                                    triggerBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Product'
                                    confirmBtnClass="btn-primary"
                                    confirmBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Product'
                                    @confirm="addItem('product')"
                                    @close="clearNewItem"
                                    keepalive
                            >
                                <slot>
                                    <label>Name</label>
                                    <input type="text" v-model="newItem" class="form-control" />
                                </slot>
                            </dropdown-confirmation>
                        </div>



                    </transition>

                    <transition name="slide" mode="out-in">
                        <div class="product-section configure-container" v-show="activeProduct.product">

                            <div class="product-choice-header" >
                                Details
                            </div>
                            <div class="product-choice-form container-fluid">
                                <div class="row">
                                    <label class="col-5">Qty</label>
                                    <div class="col-7">
                                        <input type="text" v-model="activeProduct.qty" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-5">Term</label>
                                    <div class="col-7">
                                        <input type="text" v-model="activeProduct.term" class="form-control">
                                    </div>
                                </div>

                                <div class="row">
                                    <label class="col-5">MRC</label>
                                    <div class="col-7">
                                        <input type="text" v-model="activeProduct.mrc" class="form-control">
                                    </div>
                                </div>


                                <div class="row">
                                    <label class="col-5">NRC</label>
                                    <div class="col-7">
                                        <input type="text" v-model="activeProduct.nrc" class="form-control">
                                    </div>
                                </div>

                                <div class="row">
                                    <label class="col-5"></label>
                                    <div class="col-7">
                                        <button @click="setProduct" class="btn btn-primary">Add to Quote &nbsp;&nbsp;<i class="fa fa-chevron-right"></i></button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </transition>

                </div>
                <br /><br />
                <button @click="configureLocations" class="btn btn-light"> <i class="fa fa-chevron-left"></i>&nbsp;&nbsp;PREV: Choose Locations</button>

                <button @click="nextLocation" class="btn btn-primary" style="float: right;" v-show="locationIndex < quote.locations.length - 1">&nbsp;&nbsp;Next Location <i class="fa fa-chevron-right"></i></button>
            </div>
        </div>
        <div class="quote-section quote-summary">
            <div class="quote-summary-header">
                <h4>Quote For</h4>
                <h2>{{carrier.carrier_name}}</h2>
            </div>

            <div class="quote-summary-body">

                <h4>
                    &nbsp;&nbsp;
                    Addresses ({{quote.locations.length}})</h4>
                <div v-for="l in quote.locations">
                    <div class="summary-location"  @click="expanded.locations.indexOf(l) >= 0 ? expanded.locations.splice(expanded.locations.indexOf(l), 1):expanded.locations.push(l)">
                        <div class="location-expander">
                            <i class="fa fa-minus" v-show="expanded.locations.indexOf(l) >= 0"></i>
                            <i class="fa fa-plus" v-show="expanded.locations.indexOf(l) < 0"></i>
                        </div>
                        <div class="location-detail">
                            {{l.location.formatted_address}}
                        </div>
                        <div class="location-action">
                            <button class="btn btn-clear" @click="quote.locations.splice(quote.locations.indexOf(l), 1)"><i class="fa fa-trash"></i></button>
                        </div>
                    </div>
                    <div class="summary-location-product" v-for="product in l.Products" v-show="expanded.locations.indexOf(l) >= 0" >
                        <div class="product-detail">

                            <strong>{{product.product}}</strong><br />
                            {{product.access}} / {{product.criteria}}<br /><br />
                        </div>
                        <div class="location-action">
                            <button class="btn btn-clear" @click="l.Products.splice(l.Products.indexOf(product), 1)"><i class="fa fa-trash"></i></button>
                        </div>

                        <div class="location-product-detail">
                            <div class="quoted-product-details">
                                <label>QTY:</label><span>{{product.qty}}</span>
                            </div>
                            <div class="quoted-product-details">
                                <label>Term:</label><span>{{product.term}}</span>
                            </div>
                            <div class="quoted-product-details">
                                <label>MRC:</label><span>{{product.mrc}}%</span>
                            </div>
                            <div class="quoted-product-details">
                                <label>NRC:</label><span>{{product.nrc}}%</span>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="quote-summary-footer" >


                    <button @click="saveQuote" class="btn btn-primary"v-show="locationIndex >= quote.locations.length - 1"><i class="fa fa-check"></i>&nbsp;&nbsp;Save Quote </button>
                </div>


            </div>

        </div>
    </div>
</template>

<script type="text/babel">
    import DropdownConfirmation from  "../assets/DropdownConfirmation.vue";
    export default {
        name: "Quote",
        data: function () {
            return {
                newItem:null,
                expanded: {
                    locations: [],
                    products: []
                },
                activeSection: 'locations',
                quote:{
                    leadCarrier_id:null,
                    locations:[]

                },
                num_pages: 0,
                paginate:{
                    current_page: 1,
                    limit: 5,
                    offset:0
                },
                timer:{},
                activeLocation: {
                    location_id: '',
                    address: '',
                    products:[]
                },
                carrierProducts:[],
                activeProduct: {
                    carrierProduct_id:null,
                    accessIndex: null,
                    criteriaIndex: null,
                    productIndex: null,
                    access: null,
                    criteria: null,
                    product: null,
                    term: null,
                    mrc: null,
                    nrc: null,
                    qty:  null
                },
                productAttributes:{
                    access: ['Coax', 'ABF', 'Dedicated Fiber'],
                    criteria: ['Standalone', 'Bundled'],
                    product: ['Internet Plus 100M x 10M', 'Internet Pro 400M x 20M', 'Internet Gig 940M x 35M']
                },
                leadLocations:[],
                locationIndex: 0
            }
        },
        components:{
            DropdownConfirmation
        },
        created(){
            this.quote.leadCarrier_id = this.carrier.leadCarrier_id;
            this.fetchLeadLocations();
            this.fetchCarrierProducts();

        },
        computed:{
            attributeTree(){
                var productTree = {
                    access: []
                };


                var accessIndex = 0;
                var criteriaIndex = 0;
                var attributeTree =  this.carrierProducts.map((cp, index) => {
                    accessIndex = productTree.access.findIndex(a => a.name === cp.access);
                    if(accessIndex < 0) {
                        productTree.access.push({
                            name: cp.access,
                            criteria: []
                        });
                        accessIndex = productTree.access.findIndex(a => a.name === cp.access);
                    }
                    criteriaIndex = productTree.access[accessIndex].criteria.findIndex(a => a.name === cp.criteria);
                    if(criteriaIndex  < 0) {
                        productTree.access[accessIndex].criteria.push({
                            name:cp.criteria,
                            products: []
                        });
                        criteriaIndex = productTree.access[accessIndex].criteria.findIndex(a => a.name === cp.criteria);
                    }

                    productTree.access[accessIndex].criteria[criteriaIndex].products.push({
                        name: cp.name,
                        mrc: cp.mrc,
                        nrc: cp.nrc,
                        term: cp.term,
                        qty: cp.qty,
                        access: cp.access,
                        criteria: cp.criteria,
                        carrierProduct_id: cp.carrierProduct_id
                    });
                    return productTree;
                });

                return productTree;

            },
            accessCriteria(){
                var productAccess = [];
                this.carrierProducts.forEach(cp => {
                    if(productAccess.indexOf(cp.access) < 0){
                        productAccess.push(cp.access);
                    }
                });
                return productAccess;

            }
        },
        filters:{

        },
        methods:{
            nextLocation(){
                this.resetActiveProduct();
                this.locationIndex++;
                this.expanded.locations = [this.quote.locations[this.locationIndex]];


            },
            resetActiveProduct(){
               this.activeProduct= {
                   carrierProduct_id:null,
                   accessIndex: null,
                   criteriaIndex: null,
                   productIndex: null,
                    access: null,
                    criteria: null,
                    product: null,
                    term: null,
                    mrc: null,
                    nrc: null,
                    qty:  null
                }
            },

            configureLocations(){
                this.activeSection = 'locations';
                this.expanded.locations = [];
            },
            configureProducts(){

                this.locationIndex = 0;
                this.activeSection = 'products';
                this.expanded.locations = [this.quote.locations[0]];


            },
            isSelectedLocation(location){
                var locations = this.quote.locations.filter(l => l.leadLocation_id == location.leadLocation_id);
                return locations.length;

            },
            toggleLocation(location){

                var locationIndex;
                this.quote.locations.some(function(l, index) {
                    if (l.leadLocation_id == location.leadLocation_id) {
                        locationIndex = index;
                        return true;
                    }
                });


                if(locationIndex >= 0) {
                    this.quote.locations.splice(locationIndex, 1);
                } else {

                    location.Products = [];
                    this.quote.locations.push(location);
                }

            },
            resetQuote(){
                this.createQuote = false;
            },
            getAddresses(){

            },
            fetchCarrierProducts(){
                this.$send(this, 'carrierProducts', {
                    carrier_id: this.carrier.carrier_id
                }).then(r => {
                   this.carrierProducts = r.carrierProducts

                });
            },
            setProductChoice(type,index, choice){

               // this.activeProduct[type] = choice;
                switch(type){
                    case 'access':

                        this.activeProduct.accessIndex = index;
                        this.activeProduct.access = choice;
                        this.activeProduct.criteriaIndex = null;
                        this.activeProduct.criteria = null;
                        this.activeProduct.productIndex = null;
                        this.activeProduct.product = null;
                        this.activeProduct.term = null;
                        this.activeProduct.mrc = null;
                        this.activeProduct.nrc = null;
                        this.activeProduct.qty = null;
                        this.activeProduct.carrierProduct_id = null;
                        break;
                    case 'criteria':
                        this.activeProduct.criteriaIndex = index;
                        this.activeProduct.criteria = choice;
                        this.activeProduct.productIndex = null;
                        this.activeProduct.product = null;
                        this.activeProduct.term = null;
                        this.activeProduct.mrc = null;
                        this.activeProduct.nrc = null;
                        this.activeProduct.qty = null;
                        this.activeProduct.carrierProduct_id = null;
                        break;
                    case 'product':
                        this.activeProduct.productIndex = index;
                        this.activeProduct.product = choice.name;
                        this.activeProduct.term = choice.term;
                        this.activeProduct.mrc =  choice.mrc;
                        this.activeProduct.nrc = choice.nrc;
                        this.activeProduct.qty = choice.qty;
                        this.activeProduct.carrierProduct_id = choice.carrierProduct_id;
                        break;
                }

            },

            setProduct(){

                //TODO add validation
                console.log(this.quote.locations);
                this.quote.locations[this.locationIndex].Products.push(JSON.parse(JSON.stringify(this.activeProduct)));
                this.activeProduct.productIndex = null;
                this.activeProduct.product = null;
                this.activeProduct.term = null;
                this.activeProduct.mrc =  null;
                this.activeProduct.nrc = null;
                this.activeProduct.qty = null;
                this.activeProduct.carrierProduct_id = null;


            },
            fetchLeadLocations(){
                var data = {};
                data.lead_id = this.details.lead_id;
                data.offset = this.paginate.limit * (this.paginate.current_page - 1);
                data.limit = this.paginate.limit;

                 this.timer = moment().valueOf();
                 data.time = this.timer;
                this.$send(this, 'leadLocations', data).then(r => {
                    this.leadLocations = r.leadLocations;
                    this.num_pages = Math.ceil(r.count / this.paginate.limit);

                });

            },
            addItem(type){
                if(!this.newItem) return;
                this.productAttributes[type].push(this.newItem);
                this.newItem = null;
            },
            saveQuote(){

                this.$send(this, 'leadCarrierLocationProductCreate', this.quote).then(r => {
                    this.activeSection == 'locations';
                    this.resetActiveProduct();
                    this.resetQuote();
                    this.$emit('refetch');
                    this.$emit('close');
                });
            },
            clearNewItem(){
                this.newItem = null
            }

        },
        props:['carrier', 'details']
    }


</script>

<style scoped>

    .lead-generation-container{
        display:flex;
        justify-content: space-between;
        width: 100%;

    }
    .quote-summary{
        flex-grow:0;
        flex-shrink:0;
        width: 350px;
        border: 1px solid #e2e2e2;

    }
    .quote-content{
        flex-grow:1;
        flex-shrink:1;
    }
    .quote-summary-header{
        border-bottom: 1px solid #e2e2e2;
        padding: 20px;
    }
    .quote-summary-footer{

        padding: 20px;
    }
    .quote-summary-header h4{
        font-size: 10px;
        margin: 0;
        padding: 0;
        text-transform: uppercase;
    }
    .quote-summary-body h4{
        padding: 15px 20px;
        font-size: 14px;
        margin: 0;
        border-bottom: 1px solid #e2e2e2;
    }
    .quote-summary h2{
        font-size: 16px;
        text-align: center;
        padding-top: 30px;
        padding-bottom:30px;

    }

    .quote-product-section {
        padding: 0 50px 0 0;
    }

    .location-container{
        padding: 10px 0;
        margin-bottom: 20px;
    }


    .location {
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 5px;
        padding: 8px 16px;
        border: 1px solid #e2e2e2;
        cursor: pointer;
    }

    .location.active{
        background-color: #edf4fa;
        border: 1px solid #0288d1;
    }

    .product-container{
        display:flex;
        width: 100%;
        border-bottom: 1px solid #e2e2e2;
        padding: 0 0px 20px;
    }

    .product-section{
        flex-basis: 25%;
        flex-grow: 0;
        flex-shrink: 0;
        padding-right: 15px;
        background-color: white;
    }
    .product-section:last-child{
        padding-right:0;
    }



    .summary-location{
        padding: 10px 10px 10px 20px;
        border-bottom: 1px solid #e2e2e2;
        background-color: #edf4fa;
    }

    .summary-location-product{
        padding: 10px 10px 10px 20px;
        border-bottom: 1px solid #e2e2e2;
        background-color: #FFFFFF;
    }


    .product-choice-header{
        color: #333;
        border-bottom: 1px solid #333;
        font-weight: 600;
        padding: 10px 5px;
    }

    .product-choice{
        padding: 20px 10px;
        cursor: pointer;
    }
    .product-choice:hover{
        background-color: #f5f5f5;
    }

    .product-choice.active{
        background-color: #edf4fa;
        color: #000;
    }
    .product-choice.disabled{
        opacity: .25;
    }

    .product-choice-form{
        padding: 20px;
        border: 1px solid #edf4fa;
        background-color: #edf4fa;
    }

    .product-choice-form label{
        width: 50%;
    }
    .quoted-product-details label{
        width: 25%;
    }
    .quoted-product-details span{
        margin-left: 10px;
    }


    .slide-enter-active, .slide-leave-active {
        transition: opacity .2s ease-in-out, transform .2s ease-in-out;
    }

    .slide-enter, .slide-leave-to {
        opacity: 0;
        transform: translateX(-20px);
    }
    .product-detail,
    .location-detail,
    .location-expander,
    .location-action{
        display:inline-block;
        vertical-align: top;
        width: 10%;
    }

    .location-detail{
        width: 75%;
    }
    .product-detail{
        width: 85%;
    }
    .location-product-detail{
        width: 100%;
        border-top: 1px dashed #e2e2e2;
        padding: 10px 0;
    }

</style>


// WEBPACK FOOTER //
// Quote.vue?b64ef096